/**
 * @Author:daihua
 * @Date: 2022-4-13
 */

export default {
	path: 'examineWhiteList',
	component: () => import( /* webpackChunkName: "taskBillWhitelist" */ '@/pages/autoExamineWhiteList/list'),
	meta: {
		title: '结算批次白名单'
	},
}